import useXDotcOffers from '@swarm/core/hooks/subgraph/x-dotc/useXDotcOffers'
import { DotcAsset } from '@swarm/types/tokens/dotc'
import { XOfferFilter } from '@swarm/types/x-subgraph/graphql'
import { useCallback, useMemo } from 'react'

import useGoldAssetOptions from './useGoldOffersOptions'

interface UseGoldOffersOptions {
  tokenIn?: DotcAsset
  tokenOut?: DotcAsset
  isPrivateOffers?: boolean
  skip?: boolean
}

const useGoldOffers = ({
  tokenIn,
  tokenOut,
  isPrivateOffers = false,
  skip = false,
}: UseGoldOffersOptions) => {
  const xDotcGoldOffersOptions = useGoldAssetOptions({
    tokenIn,
    tokenOut,
    isPrivateOffers,
  })

  const { offers, loadingOffers, hasMore, fetchMore, refetching, refetch } =
    useXDotcOffers(xDotcGoldOffersOptions)

  const refreshOffers = useCallback(
    (newFilter?: Partial<XOfferFilter>) =>
      refetch({
        ...xDotcGoldOffersOptions.variables.filter,
        ...newFilter,
      }),
    [refetch, xDotcGoldOffersOptions],
  )

  const loadMore = useCallback(async () => {
    if (offers && hasMore && !skip && !loadingOffers) {
      await fetchMore(offers?.length)
    }
  }, [offers, hasMore, skip, loadingOffers, fetchMore])

  return useMemo(
    () => ({
      offers,
      loadingOffers,
      hasMore,
      loadMore,
      refetching,
      refreshOffers,
    }),
    [hasMore, loadMore, loadingOffers, offers, refetching, refreshOffers],
  )
}

export default useGoldOffers
